import { render, staticRenderFns } from "./ZhiqiTong.vue?vue&type=template&id=316233e8&scoped=true"
import script from "./ZhiqiTong.vue?vue&type=script&lang=js"
export * from "./ZhiqiTong.vue?vue&type=script&lang=js"
import style0 from "./ZhiqiTong.vue?vue&type=style&index=0&id=316233e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316233e8",
  null
  
)

export default component.exports